export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key';

export const createIdempotencyKey = (): string => crypto.randomUUID();

export const idempotencyKeyHeaders = (key: string): Record<string, string> => ({
  [IDEMPOTENCY_KEY_HEADER]: key,
});
